<template>
  <div
    v-if="formDataLocal.image && imgStatus === 'success'"
    class="img-wrapper mt-4"
  >
    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
      Image Preview
    </label>

    <div class="flex flex-col w-[fit-content]">
      <div class="relative w-[fit-content]">
        <img
          draggable="false"
          :id="index ? `imgPreview-${index}` : 'imgPreview'"
          class="rounded-t-md select-none"
          :src="formDataLocal.image"
          :width="imageSize"
          @click="handleClick"
        />
        <div
          @mouseup="handleMouseUp"
          @mousedown="handleMouseDown($event, index)"
          v-for="(data, index) in formDataLocal.hotspots"
          :key="index"
          :class="`select-none absolute cursor-pointer rounded-full border border-white border-solid drop-shadow-md w-[40px] h-[40px] flex items-center justify-center`"
          :style="`left:${data.pos_left}%; top:${data.pos_top}%; width:${dotSize}px; height:${dotSize}px`"
        >
          <div
            class="w-[32px] h-[32px] bg-white rounded-full flex items-center justify-center"
          >
            <IconAbiPlus />
          </div>
        </div>
      </div>
      <div
        class="bg-abi-darkBlue h-10 rounded-b-md flex items-center justify-evenly text-white"
      >
        <p><b>Top:</b> {{ top }}%</p>
        <p><b>Left:</b> {{ left }}%</p>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "underscore";
import IconAbiPlus from "@/assets/icons/IconAbiPlus";
import * as Helpers from "@/helpers";

export default {
  components: { IconAbiPlus },
  data: function () {
    return {
      isMouseDown: false,
      currentIndex: null,
      imgStatus: "error",
      left: 0,
      top: 0
    };
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    dotSize: {
      type: Number,
      required: true
    },
    index: {
      type: String,
      required: false
    },
    imageSize: {
      type: Number,
      required: true
    }
  },
  mounted() {
    if (this.formData.image) {
      Helpers.checkImgExists(this.formData.image)
        .then(() => {
          this.imgStatus = "success";
        })
        .catch(() => {
          this.imgStatus = "error";
        });
    }
  },
  watch: {
    "formData.image"() {
      if (this.formData.image) {
        Helpers.checkImgExists(this.formData.image)
          .then(() => {
            this.imgStatus = "success";
          })
          .catch(() => {
            this.imgStatus = "error";
          });
      }
    },
    isMouseDown() {
      if (this.isMouseDown === true) {
        document.addEventListener(
          "mousemove",
          _.debounce((e) => this.handleMouseMove(e, this.currentIndex), 7)
        );
      } else {
        document.removeEventListener(
          "mousemove",
          _.debounce((e) => this.handleMouseMove(e, this.currentIndex), 7)
        );
      }
    }
  },
  computed: {
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    }
  },
  emits: ["update:formData"],
  methods: {
    handleClick(e) {
      const imgEl = document.getElementById(
        this.index ? `imgPreview-${this.index}` : "imgPreview"
      );
      let top_offset = imgEl.getBoundingClientRect().top;
      let left_offset = imgEl.getBoundingClientRect().left;
      let img_width = imgEl.offsetWidth;
      let img_height = imgEl.offsetHeight;
      let top_px = e.clientY - top_offset - this.dotSize / 2;
      let left_px = e.clientX - left_offset - this.dotSize / 2;
      this.left = ((left_px / img_width) * 100).toFixed(2);
      this.top = ((top_px / img_height) * 100).toFixed(2);
      this.formDataLocal.hotspots.push({
        pos_top: ((top_px / img_height) * 100).toFixed(2),
        pos_left: ((left_px / img_width) * 100).toFixed(2)
      });
      this.dot_count += 1;
    },
    handleMouseMove(e, index) {
      if (!this.isMouseDown) return;
      const imgEl = document.getElementById(
        this.index ? `imgPreview-${this.index}` : "imgPreview"
      );
      let top_offset = imgEl.getBoundingClientRect().top;
      let left_offset = imgEl.getBoundingClientRect().left;
      let img_width = imgEl.offsetWidth;
      let img_height = imgEl.offsetHeight;
      let top_px = e.clientY - top_offset - this.dotSize / 2;
      let left_px = e.clientX - left_offset - this.dotSize / 2;
      if (
        e.clientY > top_offset &&
        e.clientY < top_offset + img_height &&
        e.clientX > left_offset &&
        e.clientX < left_offset + img_width
      ) {
        this.left = ((left_px / img_width) * 100).toFixed(2);
        this.top = ((top_px / img_height) * 100).toFixed(2);
        this.formDataLocal.hotspots[index].pos_left = (
          (left_px / img_width) *
          100
        ).toFixed(2);
        this.formDataLocal.hotspots[index].pos_top = (
          (top_px / img_height) *
          100
        ).toFixed(2);
      } else {
        this.isMouseDown = false;
      }
    },
    handleMouseUp() {
      this.isMouseDown = false;
    },
    handleMouseDown(e, index) {
      this.isMouseDown = true;
      this.currentIndex = index;
    }
  }
};
</script>
